// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VueCookies from 'vue-cookies';
import ElementUI from 'element-ui';
import VueOnToast from 'vue-on-toast';
import Notifications from 'vue-notification';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'jquery/src/jquery.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import CKEditor from '@ckeditor/ckeditor5-vue';
import Select2 from 'v-select2-component';
import vSelect from 'vue-select';
import axios from 'axios';
import VueAxios from 'vue-axios';
import 'vue-select/dist/vue-select.css';
import '@/assets/css/customs.css';
import '../node_modules/vue-on-toast/dist/vue-on-toast.css';
import VModal from 'vue-js-modal';
import Clipboard from 'v-clipboard';
import VueConfirmDialog from 'vue-confirm-dialog';
import * as CONFIG from '@/config/index';
import helper, {
  checkPermission,
  processCrowdTokenAsync,
  processCrowdToken
} from './common/helper';

import { preloaderFinished } from './config/preloader';
import { requestPiwik } from './common/piwikRequest';
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;
Vue.use(VueCookies);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(CKEditor);
Vue.component('Select2', Select2);
Vue.component('v-select', vSelect);
Vue.use(VueAxios, axios);
Vue.use(require('vue-moment'));
Vue.use(VueOnToast);
Vue.use(Notifications);
Vue.use(VModal);
Vue.use(Clipboard);
Vue.use(VueConfirmDialog);
require('@/config/interceptor');

Vue.component('vue-confirm-dialog', VueConfirmDialog.default);
Vue.use(ElementUI);
// Install VeeValidate rules and localize
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

localize({
  en: {
    messages: {
      required: 'Chưa có thông tin',
      min: 'Số kí tự phải lớn hơn hoặc bằng {length} kí tự',
      min_value: 'Giá trị phải từ {min} trở lên',
      email: 'Địa chỉ email không hợp lệ',
      max: (_, { length }) => `Số kí tự vượt quá ${length} kí tự`
    }
  }
});

// Install VeeValidate components globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

router.beforeEach((to, from, next) => {
  let check = false;
  if (
    to.name !== 'ProcessLogout' &&
    to.name !== 'LoginPage' &&
    to.name !== 'ProcessLogin'
  ) {
    check = Vue.$cookies.isKey('accessToken');
  } else {
    check = true;
  }
  if (!check) {
    window.location.href = CONFIG.LOGIN_URL;
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  preloaderFinished();
  // requestPiwik(router);
});

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js